import { Link } from "react-router-dom";
import styles from "./MissingPage.module.css";

const MissingPage = () => {
  return (
    <div className={styles.notFoundContainer}>
      <h1 className={styles.notFoundTitle}>404 - Not Found</h1>
      <p className={styles.notFoundMessage}>
        The page you are looking for does not exist.
      </p>
      <Link className={styles.goBack} to="/dashboard">
        Visit Our Homepage
      </Link>
    </div>
  );
};

export default MissingPage;
